module.exports = {"bewizr-agenda":{"empty":{"title":"Немає подій","detail":"У вас немає запланованих подій."}}}